export const fr = {
  'brand.name': 'PAPO',
  'brand.full': 'Pouvoir Africain Pour les Organises',
  'brand.subtitle': 'Pouvoir Africain',
  'brand.suffix': 'Pour les Organises',
  'brand.copyright': '© 2026 PAPO : Pouvoir Africain Pour les Organises. Afrique libre, notre Afrique.',
  'landing.slogan.0': 'Ou notre voix ne se tait pas \u2013 Afrique libre, notre Afrique.',
  'landing.slogan.1': 'Sans peur, sans museliere \u2013 pour une Afrique de droits et de justice.',
  'landing.slogan.2': 'Unis contre le regime qui nous opprime \u2013 la liberte n\'est pas un crime.',
  'landing.slogan.3': 'Du nepotisme a l\'espoir : ensemble pour une Afrique souveraine.',
  'landing.slogan.4': 'Parle, Afrique ! Ici le peuple denonce, resiste et construit l\'avenir.',
  'landing.slogan.5': 'Cree ton Afrique. Sans peur, sans censure, que du talent et de nouvelles histoires.',
  'landing.login': 'Connexion',
  'landing.register': 'Rejoins-nous',
  'landing.join': 'Rejoins la resistance',
  'landing.haveAccount': 'J\'ai un compte',
  'landing.createAccount': 'Creer mon compte',
  'landing.feat.safe.title': 'Espace Sur',
  'landing.feat.safe.desc': 'Protege de la censure et de la surveillance. Ta voix, ta liberte.',
  'landing.feat.community.title': 'Communaute Unie',
  'landing.feat.community.desc': 'Connecte-toi avec des Africains organises qui luttent pour la souverainete et la justice.',
  'landing.feat.resist.title': 'Denonce et Resiste',
  'landing.feat.resist.desc': 'Signale les abus, partage des temoignages, construis l\'avenir de l\'Afrique.',
  'landing.feat.privacy.title': 'Confidentialite Totale',
  'landing.feat.privacy.desc': 'Tes donnees ne seront jamais vendues. Nous respectons le droit international.',
  'landing.different': 'Un reseau social',
  'landing.different2': 'different',
  'landing.differentDesc': 'Cree par et pour les Africains qui veulent vivre libres du regime.',
  'landing.heroCaption': 'Parle, Afrique ! Ici le peuple denonce, resiste et construit l\'avenir.',
  'landing.values': 'Nos Valeurs',
  'landing.valuesTitle': 'Construire une Afrique',
  'landing.valuesDemocratic': 'souveraine',
  'landing.power.title': 'Pouvoir au Peuple',
  'landing.power.desc': 'Chaque voix compte. Chaque signalement importe. Ensemble nous sommes plus forts.',
  'landing.transparency.title': 'Transparence',
  'landing.transparency.desc': 'Pas d\'algorithmes manipulateurs. Pas de donnees vendues. Pas de censure.',
  'landing.unity.title': 'Unite Africaine',
  'landing.unity.desc': 'Un espace inclusif pour tous les Africains qui revent de liberte.',
  'landing.cta.title': 'La liberte n\'est pas un crime',
  'landing.cta.desc': 'Unis contre le regime qui nous opprime. Rejoins PAPO et fais partie du changement.',
  'nav.home': 'Accueil',
  'nav.groups': 'Groupes',
  'nav.events': 'Evenements',
  'nav.messages': 'Messages',
  'nav.wallet': 'Portefeuille',
  'nav.analytics': 'Analytiques',
  'analytics.title': 'Analytiques',
  'analytics.subtitle': 'Statistiques d\'interaction et tendances',
  'analytics.reactions': 'Reactions',
  'analytics.comments': 'Commentaires',
  'analytics.messages': 'Messages',
  'analytics.profileViews': 'Visites du profil',
  'analytics.yourEngagement': 'Votre engagement',
  'analytics.othersEngagement': 'Engagement des autres',
  'analytics.totalOutgoing': 'Interactions faites',
  'analytics.totalIncoming': 'Interactions recues',
  'analytics.topFriends': 'Amis les plus interactifs',
  'analytics.noData': 'Aucune donnee d\'interaction pour le moment',
  'analytics.activityChart': 'Activite des 30 derniers jours',
  'analytics.noActivity': 'Aucune activite pendant cette periode',
  'analytics.posts': 'Publications',
  'nav.profile': 'Mon profil',
  'nav.settings': 'Parametres',
  'nav.logout': 'Deconnexion',
  'auth.email': 'Email',
  'auth.password': 'Mot de passe',
  'auth.confirmPassword': 'Confirmer le mot de passe',
  'auth.name': 'Nom complet',
  'auth.login': 'Connexion',
  'auth.register': 'Creer un compte',
  'auth.logging': 'Connexion...',
  'auth.registering': 'Creation du compte...',
  'auth.loginTitle': 'Connecte-toi a ton compte',
  'auth.registerTitle': 'Cree ton compte',
  'auth.loginSubtitle': 'Ta voix compte. L\'Afrique a besoin de toi.',
  'auth.registerSubtitle': 'Rejoins la communaute qui change l\'Afrique.',
  'auth.noAccount': 'Pas de compte ?',
  'auth.haveAccount': 'Tu as deja un compte ?',
  'auth.registerLink': 'Crees-en un maintenant',
  'auth.loginLink': 'Connecte-toi ici',
  'auth.googleLogin': 'Continuer avec Google',
  'auth.backHome': 'Retour a l\'accueil',
  'auth.fillAll': 'Remplis tous les champs',
  'auth.passNoMatch': 'Les mots de passe ne correspondent pas',
  'auth.passMin': 'Le mot de passe doit comporter au moins 6 caracteres',
  'auth.welcomeBack': 'Bon retour !',
  'auth.welcome': 'Bienvenue sur PAPO !',
  'auth.loginError': 'Erreur de connexion',
  'auth.sessionExpired': 'Votre session a expiré. Veuillez vous reconnecter.',
  'auth.registerError': 'Erreur lors de la creation du compte',
  'dash.createPost': 'Que veux-tu partager ?',
  'dash.share': 'Partager',
  'dash.myGroups': 'Mes groupes',
  'dash.seeAllGroups': 'Voir tous',
  'dash.upcomingEvents': 'Evenements a venir',
  'dash.seeAllEvents': 'Voir tous',
  'dash.members': 'membres',
  'dash.loadError': 'Erreur de chargement du fil',
  'dash.releaseToRefresh': 'Relâchez pour actualiser',
  'groups.title': 'Groupes',
  'groups.search': 'Rechercher des groupes...',
  'groups.create': 'Creer un groupe',
  'groups.new': 'Nouveau groupe',
  'groups.name': 'Nom du groupe',
  'groups.description': 'Description',
  'groups.category': 'Categorie',
  'groups.creating': 'Creation...',
  'groups.join': 'Rejoindre',
  'groups.leave': 'Quitter',
  'groups.joined': 'Membre',
  'groups.noGroups': 'Aucun groupe trouve',
  'groups.loadError': 'Erreur de chargement des groupes',
  'groups.createError': 'Erreur de creation du groupe',
  'groups.created': 'Groupe cree !',
  'groups.fillAll': 'Remplis tous les champs',
  'groups.joinedMsg': 'Tu as rejoint le groupe',
  'groups.leftMsg': 'Tu as quitte le groupe',
  'groups.cat.all': 'Tous',
  'groups.cat.general': 'General',
  'groups.cat.wellness': 'Bien-etre',
  'groups.cat.mindfulness': 'Pleine conscience',
  'groups.cat.creativity': 'Creativite',
  'groups.cat.support': 'Soutien',
  'groups.cat.learning': 'Apprentissage',
  'events.title': 'Evenements',
  'events.create': 'Creer un evenement',
  'events.new': 'Nouvel evenement',
  'events.eventTitle': 'Titre',
  'events.description': 'Description',
  'events.date': 'Date',
  'events.location': 'Lieu',
  'events.creating': 'Creation...',
  'events.attend': 'Participer',
  'events.attending': 'Inscrit',
  'events.attendees': 'participants',
  'events.noEvents': 'Aucun evenement trouve',
  'events.loadError': 'Erreur de chargement des evenements',
  'events.createError': 'Erreur de creation de l\'evenement',
  'events.created': 'Evenement cree !',
  'events.fillAll': 'Remplis tous les champs obligatoires',
  'events.attendOk': 'Inscription confirmee !',
  'events.unattendOk': 'Tu ne participeras plus',
  'events.attendError': 'Erreur de traitement',
  'msg.title': 'Messages',
  'msg.search': 'Rechercher des utilisateurs...',
  'msg.typeMessage': 'Ecris un message...',
  'msg.noConversations': 'Aucune conversation',
  'msg.startChat': 'Commence une conversation',
  'msg.selectChat': 'Selectionne une conversation',
  'msg.sendError': 'Erreur d\'envoi du message',
  'msg.report': 'Signaler l\'utilisateur',
  'msg.block': 'Bloquer l\'utilisateur',
  'search.title': 'Resultats de recherche',
  'search.placeholder': 'Rechercher...',
  'search.for': 'Resultats pour',
  'search.error': 'Erreur de recherche',
  'search.all': 'Tout',
  'search.people': 'Personnes',
  'search.posts': 'Publications',
  'search.groups': 'Groupes',
  'search.hashtags': 'Hashtags',
  'search.searching': 'Recherche...',
  'search.results': 'resultats',
  'search.users': 'Utilisateurs',
  'search.posts': 'Publications',
  'search.groups': 'Groupes',
  'search.events': 'Evenements',
  'search.hashtags': 'Hashtags',
  'wellness.title': 'Ton bien-etre',
  'wellness.session': 'Session',
  'wellness.dailyUsage': 'Utilisation quotidienne',
  'wellness.nearLimit': 'Tu approches de ta limite quotidienne. Pense a faire une pause.',
  'wellness.reminder': 'Les reseaux sociaux sont un outil, pas une obligation.',
  'wellness.takeBreak': 'Faire une pause',
  'wellness.breakTitle': 'Moment de pause',
  'wellness.sessionTime': 'Duree de session',
  'wellness.minutes': 'minutes',
  'wellness.inhale': 'Inspire',
  'wellness.hold': 'Retiens',
  'wellness.exhale': 'Expire',
  'wellness.notNow': 'Pas maintenant',
  'wellness.break5': 'Pause de 5 min',
  'wellness.restMode': 'Mode Repos',
  'wellness.endBreak': 'Terminer la pause',
  'wellness.weeklyTitle': 'Bien-être Hebdomadaire',
  'wellness.weeklySubtitle': 'Vos 7 derniers jours',
  'wellness.totalWeek': 'Total semaine',
  'wellness.avgDaily': 'Moyenne journalière',
  'wellness.breaksTaken': 'Pauses prises',
  'wellness.streak': 'Jours consécutifs',
  'wellness.currentSession': 'Session actuelle',
  'post.comment': 'Ecrire un commentaire...',
  'post.comments': 'commentaires',
  'post.loadComments': 'Voir les commentaires',
  'post.deleteConfirm': 'Supprimer la publication ?',
  'post.report': 'Signaler',
  'post.block': 'Bloquer',
  'post.moderation': 'Statut de moderation',
  'post.tip': 'Pourboire',
  'post.delete': 'Supprimer',
  'wallet.title': 'Portefeuille',
  'wallet.balance': 'Solde total',
  'wallet.send': 'Envoyer',
  'wallet.receive': 'Recevoir',
  'wallet.swap': 'Echanger',
  'wallet.stake': 'Staking',
  'wallet.transactions': 'Transactions',
  'wallet.noTransactions': 'Aucune transaction',
  'donation.title': 'Soutenir PAPO',
  'donation.desc': 'Ton don aide a maintenir la plateforme en vie et independante.',
  'donation.copy': 'Copier',
  'donation.copied': 'Copie !',
  'settings.title': 'Parametres',
  'settings.account': 'Compte',
  'settings.privacy': 'Confidentialite',
  'settings.notifications': 'Notifications',
  'settings.wellness': 'Bien-etre',
  'settings.theme': 'Theme',
  'settings.language': 'Langue',
  'settings.export': 'Exporter les donnees',
  'settings.delete': 'Supprimer le compte',
  'profile.followers': 'Abonnes',
  'profile.following': 'Abonnements',
  'profile.posts': 'Publications',
  'profile.follow': 'Suivre',
  'profile.suggestions': 'Suggestions',
  'profile.noSuggestions': 'Aucune suggestion pour le moment',
  'friends.addFriend': 'Ajouter un ami',
  'friends.friends': 'Amis',
  'friends.pending': 'En attente',
  'friends.accept': 'Accepter',
  'friends.requestSent': 'Demande envoyee',
  'friends.accepted': 'Vous etes maintenant amis!',
  'friends.removed': 'Ami supprime',
  'circles.title': "Cercles",
  'circles.new': "Nouveau cercle",
  'circles.edit': "Modifier le cercle",
  'circles.intro': "Regroupez vos amis (Famille, Travail…) et publiez seulement pour eux.",
  'circles.empty': "Vous n’avez pas encore de cercles",
  'circles.member': "membre",
  'circles.members': "membres",
  'circles.confirmDelete': "Supprimer ce cercle ? Les publications faites pour lui ne seront visibles que par vous.",
  'circles.namePlaceholder': "Nom du cercle (ex. Famille)",
  'circles.pickFriends': "Choisissez des amis",
  'circles.save': "Enregistrer",
  'circles.saved': "Cercle enregistré",
  'circles.allFriends': "Tous mes amis",
  'circles.badge': "Cercle",
  'friends.one': 'Ami',
  'friends.confirmRemove': "Voulez-vous vraiment retirer cet ami ?",
  'friends.privateProfile': 'Profil prive',
  'friends.privateDesc': 'Ce profil est prive. Ajoutez comme ami pour voir les publications.',
  'friends.requests': 'Demandes d\'amitie',
  'friends.noRequests': 'Aucune demande en attente',
  'suggestions.title': 'Personnes que tu connais peut-etre',
  'suggestions.mutualFriends': 'amis en commun',
  'suggestions.fromContacts': 'De tes contacts',
  'suggestions.newOnPapo': 'Nouveau sur PAPO',
  'suggestions.noSuggestions': 'Aucune suggestion pour le moment',
  'suggestions.syncContacts': 'Synchroniser les contacts',
  'suggestions.syncDesc': 'Trouve tes amis du telephone sur PAPO',
  'suggestions.contactsSynced': 'Contacts synchronises',
  'suggestions.synced': 'contacts synchronises',
  'suggestions.syncError': 'Erreur de synchronisation des contacts',
  'suggestions.manualPrompt': 'Entre les emails ou telephones de tes contacts separes par des virgules:',
  'msg.ephemeral': 'Message ephemere',
  'msg.ephemeralToggle': 'Le message disparait apres lecture',
  'msg.ephemeralActive': 'Mode ephemere active — les messages disparaissent apres lecture',
  'friendRequests.title': 'Demandes d\'amitie',
  'friendRequests.nav': 'Demandes',
  'friendRequests.incoming': 'Recues',
  'friendRequests.sent': 'Envoyees',
  'friendRequests.noIncoming': 'Aucune demande recue',
  'friendRequests.noSent': 'Aucune demande envoyee',
  'friendRequests.noFriends': 'Pas encore d\'amis',
  'friendRequests.wantsToBeYourFriend': 'Veut etre ton ami',
  'friendRequests.pendingSent': 'Demande en attente',
  'friendRequests.remove': 'Supprimer',
  'friends.requestRejected': 'Demande rejetee',
  'profile.unfollow': 'Ne plus suivre',
  'profile.edit': 'Modifier le profil',
  'profile.bio': 'Bio',
  'common.loading': 'Chargement...',
  'common.now': 'a l\'instant',
  'common.save': 'Enregistrer',
  'common.cancel': 'Annuler',
  'common.close': 'Fermer',
  'common.back': 'Retour',
  'common.min': 'min',
  'common.ago': 'il y a',
  'pwa.install': 'Installer l\'appli',
  'pwa.installDesc': 'Installe PAPO sur ton appareil',
  'dash.addBio': 'Ajoute une bio pour que les autres te connaissent mieux.',
  'dash.viewProfile': 'Voir le profil',
  'dash.quickActions': 'Actions rapides',
  'dash.exploreGroups': 'Explorer les groupes',
  'dash.viewEvents': 'Voir les evenements',
  'dash.noPosts': 'Aucune publication. Sois le premier a partager !',
  'dash.reactError': 'Erreur de reaction',
  'events.subtitle': 'Decouvre des experiences qui enrichissent ta vie',
  'events.noEventsDay': 'Aucun événement ce jour',
  'groups.chat': 'Discussion',
  'groups.noMessages': 'Pas encore de messages',
  'groups.typeMessage': 'Écrire un message...',
  'groups.noPosts': 'Pas encore de publications. Partagez quelque chose!',
  'chat.typing': 'écrit...',
  'polls.create': 'Créer un sondage',
  'polls.question': 'Question...',
  'polls.option': 'Option',
  'polls.addOption': 'Ajouter une option',
  'polls.publish': 'Publier le sondage',
  'polls.votes': 'votes',
  'help.title': 'Guide PAPO',
  'help.subtitle': 'Tout ce que vous devez savoir pour utiliser le réseau social, étape par étape.',
  'help.contact': 'Des questions ? Contactez',
  'help.start': 'Commencer à utiliser PAPO',
  'events.upcoming': 'Evenements a venir',
  'events.past': 'Evenements passes',
  'events.selectDate': 'Selectionne une date',
  'events.noEventsDesc': 'Sois le premier a organiser un evenement pour la communaute !',
  'events.createFirst': 'Creer le premier evenement',
  'events.confirmed': 'Confirme',
  'events.participated': 'ont participe',
  'events.locationOpt': 'Lieu (optionnel)',
  'events.titleLabel': 'Titre de l\'evenement',
  'groups.subtitle': 'Connecte-toi avec des communautes qui partagent tes interets',
  'groups.noGroupsFilter': 'Aucun groupe ne correspond a ces filtres',
  'groups.noGroupsDesc': 'Sois le premier a creer un groupe !',
  'groups.createFirst': 'Creer le premier groupe',
  'groups.membersCount': 'membres',
  'groups.groupNamePh': 'Ex : Africains pour la souverainete',
  'groups.groupDescPh': 'De quoi parle ton groupe ?',
  'groups.processError': 'Erreur de traitement',
  'msg.you': 'Toi',
  'msg.online': 'En ligne',
  'msg.today': 'Aujourd\'hui',
  'notif.title': 'Notifications',
  'notif.empty': 'Aucune notification',
  'notif.emptyDesc': 'Quand quelqu\'un interagit avec toi, ca apparaitra ici.',
  'notif.markRead': 'Marquer comme lues',
  'notif.enableBrowser': 'Activer les notifications',
  'notif.enabled': 'Notifications activees',
  'notif.disabled': 'Notifications push desactivees',
  'notif.denied': 'Notifications bloquees. Activez-les dans les parametres du navigateur.',
  'notif.enablePush': 'Activer push',
  'notif.pushActive': 'Push actif',
  'notif.blocked': 'Bloque',
  'notif.reaction': 'a reagi a ta publication',
  'notif.comment': 'a commente ta publication',
  'notif.follow': 'a commence a te suivre',
  'notif.group': 'a rejoint ton groupe',
  'post.createTitle': 'Creer une publication',
  'post.placeholder': 'Que veux-tu partager ?',
  'post.posting': 'Publication...',
  'post.publish': 'Publier',
  'post.addImage': 'Ajouter une image',
  'report.title': 'Signaler le contenu',
  'report.reason': 'Motif du signalement',
  'report.submit': 'Envoyer le signalement',
  'report.success': 'Signalement envoye. Merci.',
  'donation.support': 'Soutenir',
  'post.share': 'Partager',
  'post.linkCopied': 'Lien copie !',
  'post.commentBtn': 'Commenter',
  'admin.title': 'Panneau Admin',
  'admin.reports': 'Signalements',
  'admin.users': 'Utilisateurs',
  'admin.moderation': 'Moderation',
  'admin.stats': 'Statistiques',
  'admin.noReports': 'Aucun signalement en attente',
  'admin.resolve': 'Resoudre',
  'admin.dismiss': 'Classer',
  'admin.totalUsers': 'Total utilisateurs',
  'admin.totalPosts': 'Total publications',
  'admin.totalGroups': 'Total groupes',
  'admin.pendingReports': 'Signalements en attente',
  'settings.darkMode': 'Mode sombre',
  'settings.lightMode': 'Mode clair',
  'settings.themeAuto': 'Automatique',
  'stories.addStory': 'Ajouter story',
  'stories.yourStory': 'Ton story',
  'stories.viewers': 'Vues',
  'stories.delete': 'Supprimer',
  'stories.placeholder': 'Ecris quelque chose...',
  'stories.create': 'Creer story',
  'stories.uploadMedia': 'Photo/Video',
  'stories.react': 'Reagir',
  'mention.placeholder': 'Mentionner @utilisateur',
  'trending.title': 'Tendances',
  'poll.vote': 'Voter',
  'poll.votes': 'votes',
  'poll.voted': 'Vote',
  'poll.ended': 'Terminee',
  'poll.createPoll': 'Creer sondage',
  'poll.question': 'Question',
  'poll.option': 'Option',
  'poll.addOption': 'Ajouter option',
  'poll.duration': 'Duree (heures)',
  'groupChat.title': 'Chat du groupe',
  'groupChat.send': 'Envoyer',
  'groupChat.placeholder': 'Message...',
  'groupChat.empty': 'Pas encore de messages. Sois le premier !',
  'post.deletePost': 'Supprimer la publication',
  'post.reportContent': 'Signaler le contenu',
  'post.blockUser': 'Bloquer l\'utilisateur',
  'post.reactions': 'reactions',
  'post.tips': 'pourboire',
  'post.tipsPlural': 'pourboires',
  'post.comments': 'commentaires',
  'post.firstComment': 'Sois le premier a commenter',
  'post.commentPlaceholder': 'Ecris un commentaire...',
  'post.postDeleted': 'Publication supprimee',
  'post.postDeleteError': 'Erreur lors de la suppression',
  'post.blockSuccess': 'Utilisateur bloque',
  'post.blockError': 'Erreur lors du blocage',
  'post.copyError': 'Erreur lors de la copie',
  'post.commentError': 'Erreur lors du commentaire',
  'post.loadCommentsError': 'Erreur de chargement des commentaires',
  'post.moderationWarning': 'Avertissement de moderation :',
  'post.contentHidden': 'Contenu masque par la moderation',
  'post.publicPost': 'Publication publique',
  'post.groupPost': 'Publication dans le groupe',
  'post.fileNotAllowed': 'Type de fichier non autorise',
  'post.writeOrAdd': 'Ecris quelque chose ou ajoute un fichier',
  'post.created': 'Publication creee !',
  'post.createError': 'Erreur lors de la creation',
  'post.uploaded': 'envoye',
  'post.formDesc': 'Formulaire pour creer une nouvelle publication',
  'dash.noGroups': 'Aucun groupe disponible',
  'dash.noEvents': 'Aucun evenement a venir',
  'dash.conecta': 'Connectez-vous et satisfaites vos besoins',
  'dash.simbinDesc': 'Reseau de divertissement africain',
  'dash.assertiveDesc': 'Plateforme de networking professionnel',
  'trending.posts': 'posts',
  'stories.photoVideoOnly': 'Photos ou videos uniquement',
  'stories.created': 'Story creee !',
  'stories.error': 'Erreur',
  'search.placeholder': 'Rechercher personnes, posts, groupes, #hashtags...',
  'msg.searchPeople': 'Rechercher des personnes...',
  'msg.writePlaceholder': 'Ecris un message...',
  'groups.members': 'Membres',
  'tip.send': 'Envoyer pourboire',
  'tip.placeholder': 'Montant',
  'tip.error': 'Erreur d\'envoi du pourboire',
  'tip.amountError': 'Entre un montant valide',
  'donation.title': 'Ce n\'est que le debut',
  'donation.subtitle': 'PAPO a besoin de ton aide',
  'donation.copy': 'Copier',
  'donation.copied': 'Copie !',
  'donation.addresses': 'Adresses de don',
  'report.sent': 'Signalement envoye',
  'report.close': 'Fermer',
  'report.minChars': 'Selectionne une categorie et decris le probleme (minimum 10 caracteres)',
  'report.title': 'Signaler le contenu',
  'report.legalNote': 'Ton signalement sera analyse selon le Droit International et la legislation de l\'UE.',
  'report.categoryLabel': 'Categorie du signalement',
  'report.categoryPlaceholder': 'Selectionne une categorie...',
  'report.descLabel': 'Description',
  'report.descPlaceholder': 'Decris le probleme en detail (minimum 10 caracteres)...',
  'report.urgentNote': 'En cas de risque immediat, contacte les services d\'urgence locaux. Les signalements urgents sont automatiquement escalades.',
  'report.submit': 'Envoyer le signalement',
  'report.submitting': 'Envoi...',
  'report.received': 'Signalement recu',
  'report.priority': 'Priorite',
  'report.urgent': 'Urgent',
  'report.standard': 'Standard',
  'report.legalFrameworks': 'Cadres juridiques applicables',
  'report.submitError': 'Erreur lors du signalement',
  'report.cat.spam': 'Spam',
  'report.cat.harassment': 'Harcelement',
  'report.cat.cyberbullying': 'Cyberharcelement',
  'report.cat.threats': 'Menaces',
  'report.cat.hate_speech': 'Discours de haine',
  'report.cat.discrimination': 'Discrimination',
  'report.cat.incitement_violence': 'Incitation a la violence',
  'report.cat.child_abuse': 'Maltraitance d\'enfant',
  'report.cat.child_exploitation': 'Exploitation d\'enfant',
  'report.cat.child_grooming': 'Grooming',
  'report.cat.human_trafficking': 'Traite des etres humains',
  'report.cat.sexual_exploitation': 'Exploitation sexuelle',
  'report.cat.terrorism': 'Terrorisme',
  'report.cat.extremism': 'Extremisme',
  'report.cat.self_harm': 'Automutilation',
  'report.cat.suicide': 'Suicide',
  'report.cat.fraud': 'Fraude',
  'report.cat.scam': 'Arnaque',
  'report.cat.doxxing': 'Doxxing',
  'report.cat.privacy_violation': 'Violation de la vie privee',
  'report.cat.misinformation': 'Desinformation',
  'report.cat.other': 'Autre',
  'report.group.general': 'General',
  'report.group.cybercrime': 'Cybercriminalite',
  'report.group.discrimination': 'Discrimination et haine',
  'report.group.child_safety': 'Protection de l\'enfance',
  'report.group.trafficking': 'Traite des etres humains',
  'report.group.terrorism': 'Terrorisme',
  'report.group.safety': 'Securite personnelle',
  'report.group.fraud': 'Fraude',
  'search.popularTags': 'Hashtags populaires',
  'search.noResults': 'Aucun resultat pour',
  'search.publishHashtags': 'Publie avec des #hashtags pour qu\'ils apparaissent ici',
  'search.people': 'Personnes',
  'search.membersCount': 'membres',
  'tip.title': 'Envoyer un pourboire',
  'tip.desc': 'Soutiens {name} avec un pourboire crypto',
  'tip.chain': 'Chaine',
  'tip.amount': 'Montant',
  'tip.message': 'Message (optionnel)',
  'tip.messagePlaceholder': 'Super contenu !',
  'tip.sent': 'Pourboire envoye',
  'tip.note': 'Les pourboires sont symboliques et enregistres sur la plateforme.',
  'donation.body': 'Pour ameliorer et proteger notre communaute, nous avons besoin de soutien financier pour la protection juridique et les couts d\'infrastructure.',
  'donation.addressCopied': 'Adresse copiee !',
  'donation.close': 'Compris, merci !',
  'donation.footer': 'Chaque contribution aide a maintenir PAPO comme un espace numerique sur, libre et engage pour l\'avenir de l\'Afrique.',
  'common.error': 'Erreur',
  'reaction.empower': 'Renforcer',
  'reaction.support': 'Soutenir',
  'reaction.inspire': 'Inspirer',
  'reaction.peace': 'Paix',
  'profile.loadError': 'Erreur de chargement du profil',
  'profile.unfollowed': 'Tu ne suis plus cet utilisateur',
  'profile.followed': 'Tu suis maintenant cet utilisateur',
  'profile.listError': 'Erreur de chargement de la liste',
  'profile.reactionError': 'Erreur de reaction',
  'profile.updated': 'Profil mis a jour',
  'profile.updateError': 'Erreur de mise a jour du profil',
  'profile.photoUpdated': 'Photo mise a jour',
  'profile.photoError': 'Erreur d\'envoi de l\'image',
  'profile.memberSince': 'Membre PAPO',
  'profile.mutualFriends': 'amis en commun',
  'profile.noPosts': 'Tu n\'as encore rien publie. Partage quelque chose avec la communaute !',
  'profile.noPostsOther': 'Cet utilisateur n\'a encore rien publie.',
  'groups.catAll': 'Tous',
  'groups.catGeneral': 'General',
  'groups.catWellness': 'Bien-etre',
  'groups.catMindfulness': 'Pleine conscience',
  'groups.catCreativity': 'Creativite',
  'groups.catSupport': 'Soutien',
  'groups.catLearning': 'Apprentissage',
  'groupDetail.loadError': 'Erreur de chargement du groupe',
  'groupDetail.left': 'Tu as quitte le groupe',
  'groupDetail.joined': 'Tu as rejoint le groupe',
  'groupDetail.actionError': 'Erreur de traitement',
  'groupDetail.reactionError': 'Erreur de reaction',
  'settings.tabProfile': 'Profil',
  'settings.tabWellness': 'Bien-etre',
  'settings.tabNotifications': 'Notifications',
  'settings.tabPrivacy': 'Confidentialite',
  'settings.tabLegal': 'Legal / RGPD',
  'settings.tabAppearance': 'Apparence',
  'settings.saved': 'Profil mis a jour',
  'settings.saveError': 'Erreur de sauvegarde',
  'settings.imageTooBig': 'L\'image ne peut pas depasser 5 Mo',
  'settings.photoUpdated': 'Photo mise a jour',
  'settings.photoError': 'Erreur d\'envoi de l\'image',
  'settings.deleteRequested': 'Demande de suppression enregistree',
  'settings.deleteError': 'Erreur lors de la suppression',
  'settings.deleteCancelled': 'Demande de suppression annulee',
  'msg.blockError': 'Erreur de blocage',
  'msg.caller': 'Utilisateur',
  'msg.userNotFound': 'Utilisateur non trouve',
  'msg.blockedFromMsg': 'Bloque depuis les messages',
  'msg.userBlocked': 'Utilisateur bloque',
  'msg.yourMessages': 'Tes messages',
  'msg.selectOrSearch': 'Selectionne une conversation ou cherche quelqu\'un pour discuter',
  'msg.noChatsYet': 'Tu n\'as pas de conversations',
  'msg.searchToChat': 'Cherche des personnes pour commencer un chat',
  'msg.startConvo': 'Commence la conversation',
  'bluetooth.papoUser': 'Utilisateur PAPO',
  'settings.bioPlaceholder': 'Parle-nous de toi...',
  'settings.save': 'Enregistrer les modifications',
  'settings.currentSession': 'Session actuelle',
  'settings.maxDaily': 'Temps quotidien maximum',
  'settings.privacyTitle': 'Confidentialite et securite',
  'settings.deleteAccount': 'Supprimer mon compte',
  'settings.cancelDelete': 'Annuler la suppression',
  'settings.requestDelete': 'Demander la suppression du compte',
  'settings.deleteConfirmTitle': 'Supprimer definitivement le compte',
  'settings.cancel': 'Annuler',
  'settings.exportError': 'Erreur d\'exportation des donnees',
  'settings.title': 'Parametres',
  'settings.logout': 'Deconnexion',
  'settings.profileInfo': 'Informations du profil',
  'settings.nameLabel': 'Nom',
  'settings.wellnessConfig': 'Configuration du bien-etre numerique',
  'settings.exportData': 'Exporter mes donnees',
  'settings.legalInfo': 'Informations legales',
  'settings.dpo': 'Delegue a la protection des donnees',
  'settings.themeLabel': 'Theme',
  'settings.themeApplied': 'Theme applique',
  'settings.exportSuccess': 'Donnees exportees avec succes',
  'account.title': 'Gestion du compte',
  'account.subtitle': 'Protection des données et confidentialité (RGPD)',
  'account.exportTitle': 'Télécharger mes données',
  'account.exportDesc': 'Téléchargez toutes vos publications, messages, contacts et données dans un fichier ZIP compressé. Droit à la portabilité (RGPD Art. 20).',
  'account.downloadZip': 'Télécharger ZIP',
  'account.deactivateTitle': 'Désactiver le compte',
  'account.deactivateDesc': 'Votre profil ne sera plus visible et vous ne pourrez pas vous connecter. Vos données sont conservées.',
  'account.deactivateBtn': 'Désactiver mon compte',
  'account.deleteTitle': 'Supprimer le compte définitivement',
  'account.deleteDesc': 'Supprime toutes vos données de manière irréversible après 30 jours de grâce. Droit à l\'oubli (RGPD Art. 17).',
  'account.deleteBtn': 'Supprimer mon compte',
  'account.deleteConfirm': 'Supprimer dans 30 jours',
  'account.legalNotice': 'Vos droits en matière de protection des données sont garantis par le Règlement Général sur la Protection des Données (RGPD). Pour toute question: dpo@papo.social',
  'account.exportSuccess': 'Données téléchargées',
  'account.exportError': 'Erreur lors de l\'exportation',
  'account.exporting': 'Génération...',
  'account.deactivateConfirmTitle': 'Désactiver votre compte ?',
  'account.deactivateConfirmDesc': 'Votre profil ne sera plus visible pour les autres utilisateurs. Vous ne pourrez pas vous connecter tant que le compte ne sera pas réactivé. Vos données seront conservées.',
  'account.deactivateConfirm': 'Oui, désactiver',
  'account.deactivated': 'Compte désactivé',
  'account.deleteConfirmTitle': 'Supprimer votre compte définitivement ?',
  'account.deleteConfirmDesc1': 'Cette action est irréversible. Après 30 jours seront supprimés :',
  'account.deleteItem1': 'Votre profil et informations personnelles',
  'account.deleteItem2': 'Toutes vos publications et commentaires',
  'account.deleteItem3': 'Vos messages et conversations',
  'account.deleteItem4': 'Adhésions aux groupes et contacts',
  'account.deleteConfirmDesc2': 'Nous vous recommandons de télécharger vos données avant de supprimer le compte.',
  'account.deleteScheduled': 'Suppression programmée dans 30 jours',
  'account.deletionPending': 'Suppression programmée',
  'account.deletionDate': 'Date :',
  'account.cancelDeletion': 'Annuler la suppression',
  'account.deletionCancelled': 'Suppression annulée',
  'account.error': 'Erreur de traitement',
  'privacy.visibility': 'Visibilité',
  'privacy.public': 'Public',
  'privacy.private': 'Privé (contacts uniquement)',
  'privacy.hidden': 'Caché',
  'privacy.inviteContacts': 'Inviter des contacts',
  'privacy.searchContact': 'Chercher un contact...',
  'privacy.noContacts': 'Aucun contact',
  'settings.username': 'Nom d\'utilisateur',
  'settings.usernameDesc': 'Un alias public que les autres peuvent voir à la place de votre vrai nom.',
  'settings.showEmail': 'Afficher l\'email sur le profil',
  'settings.showEmailDesc': 'Permet aux autres utilisateurs de voir votre email sur votre profil.',
  'settings.profileVisible': 'Profil visible',
  'settings.profileVisibleDesc': 'Masquez votre profil des recherches et visites.',
  'settings.saved': 'Enregistré',
  'settings.save': 'Enregistrer',
  'profile.followersTooltip': 'Personnes qui suivent ce profil',
  'profile.followingTooltip': 'Personnes suivies par ce profil',
  'profile.friendsTooltip': 'Amitiés mutuelles',
  'profile.mutualTooltip': 'Amis en commun',
  'friends.removeFriendTooltip': 'Supprimer l\'amitié',
  'friends.pendingTooltip': 'Demande envoyée, en attente de réponse',
  'friends.acceptTooltip': 'Accepter la demande d\'amitié',
  'friends.addFriendTooltip': 'Envoyer une demande d\'amitié',
  'suggestions.friendOfFriend': 'Ami de vos amis',
  'settings.downloadBtn': 'Telecharger mes donnees',
  'settings.wellnessIntro': 'PAPO t\'aide a maintenir une utilisation saine des reseaux sociaux.',
  'settings.breakReminders': 'Rappels de pause',
  'settings.breakInterval': 'Intervalle de pause',
  'settings.dailyLimit': 'Limite d\'utilisation quotidienne',
  'settings.breakSound': 'Son doux lors des suggestions de pause',
  'settings.breakModeInfo': 'A propos du mode pause : Une fois active, tu verras un exercice de respiration guide avec des animations relaxantes. Tu peux terminer la pause a tout moment.',
  'settings.notifReactions': 'Reactions',
  'settings.notifComments': 'Commentaires',
  'settings.notifFollowers': 'Nouveaux abonnes',
  'settings.notifMessages': 'Messages',
  'settings.notifMentions': 'Mentions',
  'settings.notifGroups': 'Activite de groupe',
  'settings.pushNotif': 'Notifications push',
  'settings.pushNotifDesc': 'Recevoir des notifications dans le navigateur',
  'settings.enablePush': 'Activer les notifications push',
  'settings.disablePush': 'Desactiver les notifications push',
  'settings.publicProfile': 'Profil public',
  'settings.publicProfileDesc': 'Tout le monde peut voir ton profil',
  'settings.showOnline': 'Afficher le statut en ligne',
  'settings.showLastSeen': 'Afficher la derniere visite',
  'settings.blockedUsers': 'Utilisateurs bloques',
  'settings.blockedNone': 'Tu n\'as aucun utilisateur bloque',
  'settings.unblock': 'Debloquer',
  'settings.legalCommitment': 'Nous respectons le RGPD, la Loi sur les services numeriques (DSA), la Convention des droits de l\'enfant, le Protocole de Palerme, la Convention de Budapest et les resolutions du Conseil de securite de l\'ONU.',
  'settings.legalCommitmentTitle': 'Engagement legal de PAPO :',
  'settings.notifReactionsDesc': 'Quand quelqu\'un reagit a tes publications',
  'settings.notifCommentsDesc': 'Quand quelqu\'un commente tes publications',
  'settings.notifMessagesDesc': 'Quand tu recois un nouveau message',
  'settings.notifEvents': 'Evenements',
  'settings.notifEventsDesc': 'Rappels d\'evenements a venir',
  'settings.notifGroupsDesc': 'Nouvelles publications dans tes groupes',
  'settings.wellnessTip': 'Conseil bien-etre :',
  'settings.wellnessTipText': 'Limiter les notifications peut t\'aider a reduire l\'anxiete numerique et ameliorer ta concentration.',
  'settings.privacyIntro': 'Ta confidentialite est notre priorite. PAPO ne vendra jamais tes donnees.',
  'settings.publicProfileDesc2': 'D\'autres utilisateurs peuvent voir ton profil',
  'settings.showOnlineDesc': 'Les autres voient quand tu es connecte',
  'settings.allowDM': 'Autoriser les messages directs',
  'settings.allowDMDesc': 'N\'importe qui peut t\'envoyer des messages',
  'settings.privacyCommitTitle': 'Engagement PAPO :',
  'settings.privacyCommitText': 'Tes donnees personnelles ne seront jamais vendues ni utilisees pour la publicite. Nous les utilisons uniquement pour ameliorer ton experience.',
  'settings.legalTitle': 'Droits legaux et protection des donnees',
  'settings.legalIntro': 'PAPO respecte le RGPD, la Loi sur les services numeriques de l\'UE et le Droit International Public.',
  'settings.legalExportDesc': 'Telecharge une copie complete de toutes tes donnees personnelles : profil, publications, commentaires, messages, groupes et reactions.',
  'settings.exporting': 'Exportation...',
  'settings.legalDeleteDesc': 'Ton compte sera definitivement supprime apres 30 jours. Toutes tes donnees seront supprimees.',
  'settings.deleteWarning': 'Es-tu sur ? Cette action est irreversible. Ton compte et toutes tes donnees seront definitivement supprimes.',
  'settings.deleteConfirm': 'Supprimer definitivement',
  'settings.euRep': 'Representant UE',
  'settings.disputes': 'Resolution des litiges',
  'settings.odrEU': 'ODR de l\'UE',
  'settings.transparencyReport': 'Rapport de transparence',
  'settings.viewReport': 'Voir le rapport',
  'settings.aiModeration': 'Moderation IA',
  'settings.aiModDesc': 'Le contenu est automatiquement analyse par l\'IA',
  'settings.analyzed': 'Analyses',
  'settings.approved': 'Approuves',
  'settings.warned': 'Avertis',
  'settings.hidden': 'Masques/Escalades',
  'settings.loadingStats': 'Chargement des statistiques...',
  'settings.dailyUsage': 'Utilisation quotidienne',
  'settings.breakDesc': 'Suggerer des pauses apres un temps d\'utilisation',
  'settings.breakEvery': 'Suggerer une pause toutes les {min} minutes',
  'settings.dailyLimitDesc': 'Recevoir une alerte a l\'approche de la limite',
  'settings.alertAt': 'Alerte quand tu atteins {min} minutes',
  'settings.wellnessSounds': 'Sons de bien-etre',
  'settings.notifTitle': 'Preferences de notification',
  'settings.notifDesc': 'Configure les notifications que tu veux recevoir pour un usage sain de la plateforme.',
  'settings.appearanceTitle': 'Apparence',
  'settings.appearanceDesc': 'Personnalise l\'apparence de PAPO pour toi.',
  'settings.appearanceTip': 'Astuce : Tous les themes sont optimises pour une lecture prolongee et le mode Sombre reduit l\'emission de lumiere bleue.',
  'settings.saving': 'Enregistrement...',
  'settings.hours': 'heures',
  'theme.light': 'Clair',
  'theme.dark': 'Sombre',
  'theme.midnight': 'Minuit',
  'theme.resistance': 'Resistance',
  'settings.cancelError': 'Erreur lors de l\'annulation',
  'settings.userUnblocked': 'Utilisateur debloque',
  'settings.unblockError': 'Erreur lors du deblocage',
  'settings.accountWillDelete': 'Ton compte sera supprime le {date}.',
  'settings.blockedOn': 'Bloque le {date}',
  'settings.bioLabel': 'Bio',
  'wallet.loadError': 'Erreur de chargement du portefeuille',
  'wallet.demoFunded': 'Portefeuille demo finance',
  'wallet.fundError': 'Erreur de financement',
  'wallet.sendError': 'Erreur de transfert',
  'wallet.swapError': 'Erreur de swap',
  'wallet.stakeError': 'Erreur de staking',
  'wallet.unstakeError': 'Erreur',
  'wallet.metamaskNotFound': 'MetaMask non detecte. Installez l\'extension.',
  'wallet.metamaskConnected': 'MetaMask connecte',
  'wallet.metamaskError': 'Erreur de connexion MetaMask',
  'wallet.tabPortfolio': 'Portfolio',
  'wallet.tabMarket': 'Marche',
  'wallet.tabHistory': 'Historique',
  'wallet.tabStaking': 'Staking',
  'wallet.emptyWallet': 'Ton portefeuille est vide',
  'wallet.fundDemo': 'Financer le portefeuille demo',
  'wallet.activeStaking': 'Staking actif',
  'wallet.withdraw': 'Retirer',
  'wallet.availableStaking': 'Disponible pour le staking',
  'wallet.upToAPY': 'Jusqu\'a {apy}% APY',
  'wallet.bricsBanner': 'Paiements QR multi-pays BRICS+ — 600+ cryptomonnaies',
  'wallet.sendCrypto': 'Envoyer crypto',
  'wallet.sendDesc': 'Transfert P2P entre utilisateurs PAPO',
  'wallet.cryptocurrency': 'Cryptomonnaie',
  'wallet.selectPlaceholder': 'Selectionner...',
  'wallet.available': 'disponible',
  'wallet.recipientId': 'ID du destinataire',
  'wallet.amount': 'Montant',
  'wallet.noteOptional': 'Note (optionnel)',
  'wallet.sending': 'Envoi en cours...',
  'wallet.sendBtn': 'Envoyer',
  'wallet.sentTo': 'Envoye a {name}',
  'wallet.receivedFrom': 'Recu de {name}',
  'wallet.swapDesc': 'Echanger des cryptomonnaies — 0.3% frais',
  'wallet.from': 'De',
  'wallet.to': 'A',
  'wallet.youWillReceive': 'Tu recevras',
  'wallet.rate': 'Taux',
  'wallet.swapping': 'Echange en cours...',
  'wallet.confirmSwap': 'Confirmer le swap',
  'wallet.stakeDesc': 'Gagne du rendement sur tes cryptomonnaies',
  'wallet.annualYield': 'Rendement annuel estime',
  'wallet.stakingProgress': 'Staking en cours...',
  'wallet.confirmStaking': 'Confirmer le staking',
  'wallet.noTransactionsYet': 'Pas de transactions encore',
  'wallet.inspired': 'Inspire par',
  'profile.noPhotos': 'Tu n\'as pas encore de photos. Partage des images avec la communaute !',
  'profile.noPhotosOther': 'Cet utilisateur n\'a pas encore partage d\'images.',
  'profile.editTitle': 'Modifier le profil',
  'profile.nameLabel': 'Nom',
  'profile.bioLabel': 'Bio',
  'profile.bioPlaceholder': 'Parle-nous de toi...',
  'profile.saveChanges': 'Enregistrer les modifications',
  'profile.searchByName': 'Rechercher par nom',
  'profile.noMutual': 'Aucun ami en commun',
  'profile.mutualTitle': 'Amis en commun',
  'profile.followBack': "Suivre en retour",
  'profile.followsYou': "Vous suit",
  'profile.peopleYouMayKnow': "Personnes que vous connaissez peut-être",
  'profile.mutualFriend': "ami en commun",
  'search.recent': "Recherches récentes",
  'search.clearAll': "Tout effacer",
  'notif.view': "Voir",
  'search.discover': "Rechercher",
  'onboarding.skip': 'Passer',
  'onboarding.prev': 'Précédent',
  'onboarding.next': 'Suivant',
  'onboarding.finish': "C'est parti !",
  'onboarding.home.title': 'Accueil',
  'onboarding.home.desc': 'Votre fil : publications de vos amis et des personnes que vous suivez, classées selon vos interactions.',
  'onboarding.explore.title': 'Explorer',
  'onboarding.explore.desc': 'Découvrez des publications, des reels et de nouveaux sujets au-delà de votre cercle.',
  'onboarding.messages.title': 'Messages',
  "onboarding.messages.desc": "Discutez en privé en temps réel, avec appels vocaux et vidéo. Appuyez longuement pour réagir ou touchez ↩ pour répondre.",
  'onboarding.lives.title': 'Lives',
  "onboarding.lives.desc": "Regardez des lives ou lancez le vôtre, recevez des cadeaux et utilisez émojis et stickers afro dans le chat.",
  'onboarding.wallet.title': 'Wallet',
  'onboarding.wallet.desc': 'Votre portefeuille multichain : soldes, envoi et réception de crypto et de pourboires.',
  'onboarding.search.title': 'Rechercher',
  'onboarding.search.desc': 'Trouvez des personnes, publications, groupes et hashtags. Vos recherches récentes sont gardées ici.',
  'onboarding.notifications.title': 'Notifications',
  'onboarding.notifications.desc': 'Voyez instantanément réactions, commentaires et demandes d’amitié.',
  'onboarding.wellness.title': 'Bien-être',
  'onboarding.wellness.desc': 'Suivez votre temps d’écran quotidien et faites une pause quand vous en avez besoin.',
  'onboarding.profile.title': 'Profil',
  "onboarding.profile.desc": "Modifiez votre profil et voyez vos amis. Ce menu contient le Guide PAPO et les nouveautés.",
  'landing.slides.kicker': 'Tout ce que vous pouvez faire',
  'landing.slides.heading': 'Découvrez PAPO, fonction par fonction',
  'landing.slides.feed.title': 'Fil intelligent',
  'landing.slides.feed.desc': 'Votre accueil apprend avec qui vous interagissez le plus et vous montre d’abord ce qui compte vraiment.',
  'landing.slides.wellness.title': 'Bien-être numérique',
  'landing.slides.wellness.desc': 'Minuteur, limite quotidienne et pauses guidées pour que le réseau social vous rende du temps.',
  'landing.slides.lives.title': 'Lives avec invités',
  'landing.slides.lives.desc': 'Lancez un direct, invitez quelqu’un en écran partagé et recevez réactions et pourboires en temps réel.',
  'landing.slides.offline.title': 'Messages sans internet',
  'landing.slides.offline.desc': 'Discutez par Bluetooth de téléphone à téléphone sans réseau : idéal en zone rurale et en cas d’urgence.',
  'landing.slides.stickers.title': 'Stickers afrocentriques',
  'landing.slides.stickers.desc': 'Exprimez votre identité avec des stickers animés inspirés des cultures africaines, du Sahel à l’Atlas et au Cap.',
  'landing.slides.wallet.title': 'Portefeuille multichain',
  'landing.slides.wallet.desc': 'Gardez, envoyez et recevez des cryptos sur plusieurs réseaux et soutenez les créateurs par des pourboires.',
  'landing.slides.privacy.title': 'La vie privée d’abord',
  'landing.slides.privacy.desc': 'Vos données vous appartiennent : profils privés, blocage, signalements et conformité stricte.',
  'landing.slides.groups.title': 'Groupes et événements',
  'landing.slides.groups.desc': 'Créez des communautés, organisez des rencontres et célébrez avec les vôtres, en ligne et en vrai.',
  'landing.slides.explore.title': 'Rechercher et Explorer',
  'landing.slides.explore.desc': 'Trouvez personnes, publications, groupes et hashtags tendance, avec filtres et recherches récentes.',
  'landing.slides.languages.title': '4 langues et thème double',
  'landing.slides.languages.desc': 'PAPO parle portugais, anglais, espagnol et français, en mode clair ou sombre.',
  'landing.slides.try': 'Essayer',
  'landing.demo.feed': 'Votre fil',
  'landing.demo.react': 'Réactions',
  'landing.demo.live': 'En direct',
  'landing.demo.chat': 'Messages',
  'landing.demo.guest': 'Invitée',
  'landing.demo.msg1': 'Bien arrivé à Tamanrasset ?',
  'landing.demo.msg2': 'Oui ! Pas de réseau, mais PAPO marche en Bluetooth 🙌🏽',
  'landing.demo.offline': 'Envoyé sans internet',
  'testimonials.kicker': 'Voix de la communauté',
  'testimonials.heading': 'De Dakar à l’Atlas, voici ce que disent les nôtres',
  'testimonials.formTitle': 'Partagez votre expérience',
  'testimonials.formDesc': 'Dites-nous ce que PAPO représente pour vous. Une fois approuvé, il apparaîtra sur la page d’accueil avec votre nom et votre ville.',
  'testimonials.quote': 'Votre témoignage',
  'testimonials.quotePlaceholder': 'Au moins 20 caractères...',
  'testimonials.city': 'Ville',
  'testimonials.country': 'Pays',
  'testimonials.submit': 'Envoyer',
  'testimonials.update': 'Mettre à jour',
  'testimonials.delete': 'Supprimer',
  'testimonials.sent': 'Merci ! Votre témoignage est en cours de validation',
  'testimonials.status.pending': 'En validation',
  'testimonials.status.approved': 'Approuvé',
  'testimonials.status.rejected': 'Refusé',
  'testimonials.status.all': 'Tous',
  'testimonials.adminTab': 'Témoignages',
  'testimonials.approve': 'Approuver',
  'testimonials.reject': 'Refuser',
  'testimonials.none': 'Aucun témoignage ici',
  'settings.tabCommunity': 'Communauté et aide',
  'settings.replayGuide': 'Revoir le guide',
  'settings.replayGuideDesc': 'Refaites la visite des boutons principaux de PAPO quand vous voulez.',
  'settings.replayGuideBtn': 'Voir le guide',
  'admin.signupSources': 'Inscriptions par fonction (Essayer)',
  'admin.noSignupSources': 'Pas encore d’inscriptions depuis le carrousel',
  'auth.regNamePh': 'Votre nom',
  'auth.regEmailPh': 'vous@email.com',
  'auth.regPassPh': 'Au moins 6 caractères',
  'auth.regConfirmPh': 'Répétez votre mot de passe',
  'auth.regOrWith': 'ou inscrivez-vous avec',
  'upload.optimized': 'Photo optimisée',
  'stream.share': 'Partager',
  'stream.shareTitle': 'Partager le live',
  'stream.shareText': 'Rejoins mon live sur PAPO !',
  'stream.searchPeople': 'Rechercher des amis et abonnements',
  'stream.noPeople': 'Personne à afficher',
  'stream.sendTo': 'Envoyer',
  'stream.sharedWith': 'Live envoyé à',
  'stream.copyLink': 'Copier le lien',
  'stream.linkCopied': 'Lien copié !',
  'stream.more': 'Plus',
  'stream.tapForSound': 'Touchez pour activer le son',
  'stream.ended': 'Ce live est terminé',
  'stream.removeGuest': "Retirer l'invité",
  'stream.youWereRemoved': "L'hôte vous a retiré du live",
  'stream.guestsFull': 'Ce live a déjà 4 invités',
  'stream.weakConnection': 'Connexion faible : la vidéo peut se figer',
  'stream.quality.good': 'Bonne connexion',
  'stream.quality.fair': 'Connexion moyenne',
  'stream.quality.poor': 'Mauvaise connexion',
  'stream.latency': 'Latence',
  'stream.packetLoss': 'Perte de paquets',
  'stream.cover': 'Couverture (optionnelle)',
  'stream.coverHint': 'Affichée quand le lien est partagé sur WhatsApp ou Facebook',
  'stream.notifyFollowers': 'Prévenir mes amis',
  'stream.followersNotified': 'Amis prévenus',
  'stream.followersAlreadyNotified': 'Vous avez déjà prévenu vos amis pour ce live',
  'stream.askToJoin': 'Demander à monter',
  'stream.cancelRequest': 'Annuler',
  'stream.joinRequests': 'Demandes',
  'stream.wantsToJoin': 'veut rejoindre le live',
  'stream.requestRejected': "L'hôte a refusé votre demande. Réessayez dans 30 s",
  'stream.accept': 'Accepter',
  'stream.reject': 'Refuser',
  'stream.liveNow': 'En direct',
  'profile.noFollowers': 'Pas encore de followers',
  'profile.notFollowing': 'Ne suit personne encore',
  'profile.reactions': 'reactions',
  'profile.gallery': 'Galerie',
  'profile.whatToShare': 'Que veux-tu partager, {name} ?',
  'post.video': 'Video',
  'post.photo': 'Photo',
  'post.link': 'Lien',
  'videoCall.connecting': 'Connexion...',
  'videoCall.ringing': 'Appel...',
  'videoCall.media': 'Autorisez le microphone pour appeler.',
  'videoCall.connection': 'Connexion perdue. Veuillez réessayer.',
  'videoCall.timeout': 'Aucune réponse. Réessayez plus tard.',
  'videoCall.rejected': 'L’appel a été refusé ou la personne est occupée.',
  'videoCall.ended': 'Appel termine',
  'bluetooth.enable': 'Activer',
  'bluetooth.disable': 'Desactiver',
  'bluetooth.searchPeers': 'Recherche des pairs proches pour se connecter',
  'bluetooth.noMessages': 'Pas de messages encore. Envoie le premier !',
  'bluetooth.panicTitle': 'Mode panique - Supprimer toutes les donnees',
  'bluetooth.tagline': 'Sans internet - Sans censure - Chiffre de bout en bout',
  'bluetooth.nearbyPeers': 'Pairs proches',
  'groups.joinToPost': 'Rejoins le groupe pour voir et creer des publications.',
  'auth.authError': 'Erreur d\'authentification',
  'stream.title': 'Streaming en direct',
  'stream.subtitle': 'Diffusions en direct de la communaute PAPO',
  'stream.category': 'Categorie',
  'stream.allLives': 'Toutes',
  'stream.cat.general': 'General',
  'stream.cat.music': 'Musique',
  'stream.cat.talk': 'Discussion',
  'stream.cat.gaming': 'Jeux',
  'stream.cat.cooking': 'Cuisine',
  'stream.cat.education': 'Education',
  'stream.cat.fitness': 'Fitness',
  'stream.cat.culture': 'Culture',
  'stream.goLive': 'Passer en direct',
  'stream.goLiveDesc': 'Lance une diffusion en direct pour la communaute',
  'stream.titleLabel': 'Titre',
  'stream.titlePlaceholder': 'Donne un titre a ta diffusion...',
  'stream.descLabel': 'Description',
  'stream.descPlaceholder': 'De quoi vas-tu parler ?',
  'stream.privacy': 'Confidentialite',
  'stream.public': 'Public',
  'stream.private': 'Prive',
  'stream.startStreaming': 'Commencer a diffuser',
  'stream.createError': 'Erreur de creation du stream',
  'stream.end': 'Terminer',
  'stream.guestJoined': 'a rejoint le live!',
  'stream.guestDeclined': 'a refuse l\'invitation',
  'stream.guestInviteTitle': 'Rejoindre le Live',
  'stream.guestInviteDesc': 'L\'hote vous invite a participer avec votre camera et microphone. Tous les spectateurs vous verront et entendront.',
  'stream.guestAccepted': 'Vous avez rejoint le live! Votre camera est active.',
  'stream.joinLive': 'Rejoindre',
  'stream.decline': 'Refuser',
  'stream.leaveGuest': 'Quitter le Live',
  'stream.guests': 'invites',
  'stream.you': 'Vous',
  'stream.liveChat': 'Chat en direct',
  'stream.chatPlaceholder': 'Ecris un message...',
  'stream.sendTip': 'Envoyer un pourboire',
  'stream.tipSent': 'Pourboire envoye !',
  'stream.tipped': 'a donne un pourboire de',
  'stream.inviteCohost': 'Inviter un co-animateur',
  'stream.cohostInvited': 'Co-animateur invite !',
  'stream.searchUser': 'Rechercher un utilisateur...',
  'stream.noStreams': 'Aucune diffusion en direct',
  'stream.beFirst': 'Sois le premier a passer en direct !',
  'stream.notFound': 'Diffusion non trouvee',
  'stream.hasEnded': 'La diffusion est terminee',
  'stream.cameraError': 'Erreur d\'acces a la camera',
  // Screen Share
  'stream.screenShare': 'Partage d\'ecran',
  'stream.screenShareStarted': 'Partage d\'ecran demarre',
  'stream.screenShareError': 'Erreur de partage d\'ecran',
  // Story Highlights
  'highlights.title': 'A la une',
  'highlights.added': 'Ajoute aux a la une!',
  'highlights.removed': 'Retire des a la une',
  'highlights.story': 'A la une',
  'highlights.remove': 'Retirer',
  // Post Scheduling
  'post.schedule': 'Programmer',
  'post.scheduleFor': 'Programmer pour',
  'post.willPublishAt': 'Sera publie a',
  'post.scheduled': 'Publication programmee!',
  'post.scheduleBtn': 'Programmer',
  'post.scheduledLabel': 'Programme',
  // Post Preview
  'post.previewTitle': 'Apercu de la publication',
  // Highlight Albums
  'albums.new': 'Nouveau',
  'albums.create': 'Creer un album',
  'albums.edit': 'Modifier l\'album',
  'albums.save': 'Enregistrer',
  'albums.delete': 'Supprimer',
  'albums.created': 'Album cree!',
  'albums.updated': 'Album mis a jour!',
  'albums.deleted': 'Album supprime!',
  'albums.empty': 'Aucune histoire dans cet album',
  'albums.nameLabel': 'Nom de l\'album',
  'albums.namePlaceholder': 'Ex: Voyages, Moments...',
  'albums.selectStories': 'Selectionner les histoires',
  'albums.noHighlights': 'Marquez d\'abord des histoires comme a la une',
  // Annotations
  'annotations.pen': 'Crayon',
  'annotations.text': 'Texte',
  'annotations.rect': 'Rectangle',
  'annotations.arrow': 'Fleche',
  'annotations.eraser': 'Gomme',
  'annotations.clear': 'Tout effacer',
  'annotations.enterText': 'Saisissez le texte:',
  // Explore
  'explore.title': 'Explorer',
  'explore.subtitle': 'Publications des amis de vos amis',
  'explore.all': 'Tout',
  'explore.photos': 'Photos',
  'explore.videos': 'Videos',
  'explore.empty': 'Aucun contenu media pour le moment',
  'explore.emptyFeed': 'Rien a explorer pour le moment',
  'explore.emptyFeedDesc': 'Ajoutez plus d\'amis pour decouvrir des publications d\'amis d\'amis',
  'explore.loadMore': 'Charger plus',
  'explore.loading': 'Chargement...',
  // Theme toggle
  'nav.explore': 'Explorer',
  'nav.darkMode': 'Mode sombre',
  'nav.lightMode': 'Mode clair',
  // Music
  'music.selectTrack': 'Choisir la musique',
  'music.search': 'Rechercher de la musique...',
  'music.addMusic': 'Ajouter de la musique',
  'stickers.title': 'Autocollants',
  'stickers.placed': 'autocollants',
  'stickers.power': 'Pouvoir',
  'stickers.culture': 'Culture',
  'stickers.nature': 'Nature',
  'stickers.food': 'Nourriture',
  'stickers.unity': 'Unite',
  // Post Analytics
  'post.analytics': 'Statistiques',
  'post.analyticsTitle': 'Analyse de la publication',
  'post.views': 'Vues',
  'post.shares': 'Partages',
  'post.linkCopied': 'Lien copie!',
  'post.reactions': 'Reactions',
  // Explore Reels
  'explore.reels': 'Reels',
  'explore.viewAll': 'Voir tout',
  // Voice Messages
  'voice.voiceMessage': 'Message vocal',
  'voice.sendError': 'Erreur d\'envoi du message vocal',
  'voice.micError': 'Erreur d\'acces au microphone',
  "gifts.title": "Envoyer un cadeau",
  "gifts.send": "Envoyer",
  "gifts.balance": "Solde",
  "gifts.coins": "pièces PAPO",
  "gifts.payWithCoins": "Pièces",
  "gifts.payWithCrypto": "Portefeuille crypto",
  "gifts.commissionNote": "Chaque cadeau inclut une commission de 0,99 % pour PAPO.",
  "gifts.cryptoNote": "1 pièce = 0,01 USD, débité de votre portefeuille.",
  "gifts.sent": "Cadeau envoyé !",
  "gifts.insufficient": "Solde insuffisant",
  "gifts.sentBy": "{name} a envoyé {gift}",
  "gifts.earnings": "Cadeaux reçus",
  "gifts.earningsDesc": "Convertissez les pièces de vos cadeaux en pourboire enregistré sur votre solde.",
  "gifts.convert": "Convertir en pourboire",
  "gifts.converted": "{n} pièces converties en pourboire",
  "gifts.noEarnings": "Aucun cadeau à convertir pour le moment",
  "gifts.djembe": "Djembé",
  "gifts.kente": "Kente",
  "gifts.sankofa": "Sankofa",
  "gifts.baobab": "Baobab",
  "gifts.mask": "Masque",
  "gifts.amazigh": "Yaz amazigh",
  "gifts.lion": "Lion",
  "gifts.crown": "Couronne",
  "mods.title": "Modérateurs",
  "mods.desc": "Choisissez jusqu'à 3 amis ou personnes que vous suivez pour modérer le chat.",
  "mods.search": "Rechercher des amis",
  "mods.add": "Nommer",
  "mods.remove": "Retirer",
  "mods.limit": "3 modérateurs maximum",
  "mods.none": "Aucun ami ou abonnement à afficher",
  "mods.granted": "{name} vous a nommé modérateur de son live",
  "mods.deleteMsg": "Supprimer le message",
  "mods.muteChat": "Rendre muet dans le chat",
  "mods.unmuteChat": "Autoriser le chat",
  "mods.kick": "Exclure du live",
  "mods.kickConfirm": "Exclure {name} de ce live ?",
  "mods.userKicked": "{name} a été exclu",
  "mods.kicked": "Vous avez été exclu de ce live",
  "mods.youAreMuted": "Un modérateur vous a rendu muet dans le chat",
  "mods.youAreUnmuted": "Vous pouvez à nouveau écrire dans le chat",
  "sched.schedule": "Programmer pour plus tard",
  "sched.create": "Programmer le live",
  "sched.created": "Live programmé. Vos amis peuvent activer un rappel.",
  "sched.invalidDate": "Choisissez une date future (30 jours max.)",
  "sched.upcoming": "Bientôt",
  "sched.remind": "Me rappeler",
  "sched.reminded": "Nous vous préviendrons",
  "sched.remindOn": "Rappel 10 min avant et au début",
  "sched.startNow": "Commencer",
  "sched.cancel": "Annuler",
  "sched.cancelConfirm": "Annuler ce live programmé ?",
  "sched.cancelled": "Live programmé annulé",
  "admin.commissions": "Commissions",
  "admin.commissionsCoins": "Pièces collectées (compte PAPO)",
  "admin.commissionsRate": "Taux de commission",
  "stickers.amazigh_dancer": "Danseuse amazighe",
  "stickers.mint_tea": "Thé à la menthe",
  "stickers.gnawa": "Musicien gnaoua",
  "stickers.afro_pick": "Peigne afro",
  "stickers.boombox": "Breakdance",
  "stickers.jazz": "Jazz",
  "stickers.steelpan": "Steelpan",
  "stickers.carnival": "Carnaval",
  "stickers.reggae_lion": "Lion reggae",
  "stickers.capoeira": "Capoeira",
  "stickers.conga": "Conga",
  "stickers.palenquera": "Palenquera",
  "stickers.didgeridoo": "Didgeridoo",
  "stickers.kangaroo": "Kangourou dot-art",
  "stickers.group.moor": "Afrique maure et amazighe",
  "stickers.group.afroamerican": "Afro-américain",
  "stickers.group.afrocaribbean": "Afro-caribéen",
  "stickers.group.afrolatin": "Afro-latino",
  "stickers.group.aboriginal": "Aborigène d’Australie",
  "coins.recharge": "Recharger",
  "coins.shopTitle": "Recharger des pièces PAPO",
  "coins.shopDesc": "Payez avec votre portefeuille crypto. 1 pièce = 0,01 USD.",
  "coins.fee": "commission",
  "coins.commissionNote": "Chaque achat inclut une commission de 0,99 % pour PAPO.",
  "coins.bought": "+{n} pièces ajoutées !",
  "coins.insufficientCrypto": "Solde {sym} insuffisant",
  "gifts.topGifters": "Top donateurs",
  "sched.addCalendar": "Ajouter au calendrier",
  "admin.commissionsDaily": "Commissions par jour",
  "admin.source.live_gift": "Cadeau en live",
  "admin.source.coin_purchase": "Achat de pièces",
  "stickers.tabEmojis": "Emojis",
  "stickers.tabAfro": "Émojis Afro",
  "stickers.tabDiaspora": "Diaspora",
  "stickers.recent": "Récents",
  "stickers.popular": "Animés populaires",
  "admin.commissionsCrypto": "Commissions crypto",
  "admin.coinReserve": "Réserve des ventes de pièces",
  "coins.walletBalance": "Solde du portefeuille",
  "admin.commissionsCount": "Commissions enregistrées",
  "stickers.kwanzaa": "Kwanzaa",
  "stickers.samba": "Samba du carnaval",
  "stickers.yennayer": "Yennayer",
  "stickers.juneteenth": "Juneteenth",
  "stickers.elephant": "Éléphant",
  "stickers.giraffe": "Girafe",
  "stickers.zebra": "Zèbre",
  "stickers.hippo": "Hippopotame",
  "stickers.jollof": "Riz jollof",
  "stickers.feijoada": "Feijoada",
  "stickers.ackee": "Ackee et morue",
  "stickers.tagine": "Tajine",
  "stickers.premium": "Packs premium",
  "stickers.unlock": "Débloquer",
  "stickers.unlocked": "Pack débloqué ! Solde : {balance} pièces",
  "stickers.pack.fiestas": "Fêtes de la diaspora",
  "stickers.pack.fauna": "Animaux d'Afrique",
  "stickers.pack.sabores": "Cuisine traditionnelle",
  "badges.rank1": "Top 1 donateur",
  "badges.rank2": "Top 2 donateur",
  "badges.rank3": "Top 3 donateur",
  "badges.inProgress": "en cours",
  "badges.tooltip": "Rang {rank} du mois · {coins} pièces offertes",
  "badges.leaderboard": "Top donateurs du mois",
  "payment.checking": "Confirmation du paiement…",
  "payment.success": "Paiement réussi !",
  "payment.cancelled": "Paiement annulé",
  "payment.error": "Impossible de confirmer le paiement",
  "payment.coinsAdded": "Vos pièces PAPO sont sur votre solde",
  "payment.back": "Retour aux Lives",
  "coins.payCard": "Carte",
  "coins.total": "Total",
  "admin.source.sticker_pack": "Pack de stickers",
  "admin.source.coin_purchase_card": "Achat de pièces (carte)",
  "admin.usdCard": "USD (carte)",
  "admin.commissionsByCurrency": "Commissions par devise",
  "coins.shopDescCard": "Payez par carte en toute sécurité avec Stripe. 1 pièce = 0,01 USD.",
  "reset.forgotLink": "Mot de passe oublié ?",
  "reset.forgotTitle": "Récupérez votre compte",
  "reset.forgotSubtitle": "Saisissez votre e-mail et nous vous enverrons un lien pour choisir un nouveau mot de passe.",
  "reset.sendLink": "Envoyer le lien",
  "reset.sent": "Si l'e-mail est enregistré, vous recevrez un lien dans quelques minutes. Vérifiez aussi les spams. Le lien expire dans 1 heure.",
  "reset.resetTitle": "Nouveau mot de passe",
  "reset.resetSubtitle": "Choisissez un mot de passe d’au moins 8 caractères.",
  "reset.newPassword": "Nouveau mot de passe",
  "reset.confirmPassword": "Répétez le mot de passe",
  "reset.save": "Enregistrer",
  "reset.done": "Mot de passe mis à jour. Vous pouvez vous connecter.",
  "reset.invalid": "Ce lien est invalide ou a expiré.",
  "reset.requestNew": "Demander un nouveau lien",
  "reset.tooShort": "8 caractères minimum",
  "reset.mismatch": "Les mots de passe ne correspondent pas",
  "reset.adminLink": "Lien de réinitialisation",
  "reset.linkCopied": "Lien copié (valable 1 heure). Envoyez-le à l'utilisateur.",
  "auth.tooManyAttempts": "Trop de tentatives. Attendez 15 minutes.",
  "authToggle.login": "Se connecter",
  "authToggle.register": "S'inscrire",
  "authToggle.label": "Accès à PAPO",
  "download.title": "Télécharger PAPO",
  "download.desc": "Installez l'app sur votre mobile : gratuite, légère et sans store.",
  "download.android": "Télécharger pour Android",
  "download.ios": "Télécharger pour iPhone",
  "download.installed": "PAPO est déjà installée sur cet appareil.",
  "download.androidTitle": "Installer sur Android",
  "download.iosTitle": "Installer sur iPhone / iPad",
  "download.android1": "Ouvrez cette page dans Chrome.",
  "download.android2": "Touchez le menu ⋮ (en haut à droite).",
  "download.android3": "Choisissez « Installer l'application » ou « Ajouter à l'écran d'accueil ».",
  "download.ios1": "Ouvrez cette page dans Safari.",
  "download.ios2": "Touchez le bouton Partager (carré avec une flèche vers le haut).",
  "download.ios3": "Choisissez « Sur l'écran d'accueil » puis « Ajouter ».",
  "download.done": "C'est compris",
  "videoCall.speaker": "Haut-parleur",
  "videoCall.mic": "Micro",
  "videoCall.camera": "Caméra",
  "videoCall.hangup": "Raccrocher",
  "emojiCat.afro": "Afrique et Angola",
  "emojiCat.afro-unity": "Unité et Résistance",
  "emojiCat.afro-nature": "Nature Africaine",
  "emojiCat.afro-food": "Saveurs d'Angola",
  "emojiCat.happy": "Joyeux",
  "emojiCat.love": "Amour",
  "emojiCat.gesture": "Gestes",
  "emojiCat.hearts": "Cœurs",
  "emojiCat.celebration": "Fête",
  "emojiCat.nature": "Nature",
  "videoCall.incoming": "Appel vidéo entrant...",
  "video.processing": "Optimisation de la vidéo… (cela peut prendre un moment)",
  "video.processingShort": "Optimisation…",
  "video.trimmedStory": "Votre vidéo a été coupée à 2 minutes pour la story",
  "video.trimmedPost": "Votre vidéo a été coupée à 10 minutes",
  "video.failed": "La vidéo n'a pas pu être traitée",
  "videoCall.switchCamera": "Pivoter",
  "stories.maxSize": "500 Mo maximum",
  "reactions.title": "Réactions",
  "reactions.all": "Toutes",
  "reactions.remove": "Retirer ma réaction",
  "reactions.you": "Vous",
  "iosPush.installTitle": "Recevez des notifications sur votre iPhone",
  "iosPush.step1": "Touchez le bouton Partager de Safari",
  "iosPush.step2": "Choisissez « Sur l'écran d'accueil »",
  "iosPush.step3": "Ouvrez PAPO depuis l'icône et activez les notifications",
  "iosPush.activateTitle": "Activez les notifications",
  "iosPush.activateDesc": "Soyez averti instantanément des messages, amis et événements.",
  "iosPush.activate": "Activer les notifications",
  "iosPush.later": "Plus tard",
  "groups.backToGroups": "Retour aux groupes",
  "groups.aboutGroup": "À propos de ce groupe",
  "download.safari1": "Touchez le bouton Partager (carré avec une flèche ⬆) dans la barre de Safari, en bas.",
  "download.safari2": "Faites défiler et choisissez « Sur l'écran d'accueil ».",
  "download.safari3": "Touchez « Ajouter » : l'icône PAPO apparaîtra sur votre écran d'accueil.",
  "download.chrome1": "Touchez le bouton Partager (carré avec une flèche ⬆) en haut à droite, près de l'adresse.",
  "download.chrome2": "Choisissez « Ajouter à l'écran d'accueil » (faites défiler la liste si besoin).",
  "download.chrome3": "Touchez « Ajouter » : l'icône PAPO apparaîtra sur votre écran d'accueil.",
  "download.firefox1": "Touchez le menu ☰ en bas à droite.",
  "download.firefox2": "Choisissez « Partager » puis « Ajouter à l'écran d'accueil ».",
  "download.firefox3": "Touchez « Ajouter » : l'icône PAPO apparaîtra sur votre écran d'accueil.",
  "download.iosNote": "Apple n'autorise pas l'installation d'un site en un seul bouton : cela se fait depuis le menu Partager.",
  "download.copyLink": "Copier le lien",
  "download.linkCopied": "Lien copié",
  "download.arrowHint": "Partager est ici",
  "download.animCopy": "Copier",
  "download.animAdd": "Sur l'écran d'accueil",
  "download.animStep1": "1 · Touchez Partager",
  "download.animStep2": "2 · « Sur l'écran d'accueil »",
  "download.animStep3": "3 · PAPO est sur votre iPhone !",
  "reply.reply": "Répondre",
  "reply.replyingTo": "Réponse à",
  "reply.cancel": "Annuler la réponse",
  "emailPrivacy.show": "Afficher mon e-mail à tous",
  "emailPrivacy.hide": "Masquer mon e-mail",
  "emailPrivacy.nowVisible": "Votre e-mail est maintenant visible par tous",
  "emailPrivacy.nowHidden": "Votre e-mail est masqué",
  "emailPrivacy.publicLabel": "Public",
  "emailPrivacy.hiddenLabel": "Masqué",
  "audience.public": "Public",
  "audience.friends": "Amis",
  "audience.private": "Moi uniquement",
  "audience.onlyMe": "Vous seul",
  "audience.who": "Qui peut voir ?",
  "audience.saved": "Confidentialité mise à jour",
  "privacyPanel.title": "Qui voit vos données",
  "privacyPanel.desc": "Résumé de ce que voit chacun : le public, vos amis et vous seul.",
  "privacyPanel.data": "Donnée",
  "privacyPanel.nameBio": "Nom, photo et bio",
  "privacyPanel.email": "E-mail",
  "privacyPanel.phone": "Téléphone",
  "privacyPanel.birthdate": "Date de naissance",
  "privacyPanel.notSet": "Pas encore ajouté (Modifier le profil)",
  "privacyPanel.emailHint": "Affichez ou masquez votre e-mail avec l'icône œil sur votre profil ou l'interrupteur ci-dessous.",
  "profile.phoneLabel": "Téléphone",
  "profile.birthdateLabel": "Date de naissance",
  "profile.personalHint": "Facultatifs. Par défaut, vous seul les voyez ; choisissez qui peut les voir avec l'icône œil sur votre profil.",
  "embed.play": "Lire la vidéo de",
  "embed.openIn": "Ouvrir dans",
};
